import script from "./MyBookList.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBookList.vue?vue&type=script&setup=true&lang=js"

import "./MyBookList.vue?vue&type=style&index=0&id=05e01510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e01510"]])

export default __exports__